import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

import EndpointsView from "./endpoints/EndpointsView";
import IntroductionView from "./introduction/IntroductionView";
import style from "./swagger.scss";
import BackToTop from "components/icons/BackToTop";
import { getPublicApiDocumentationUrl } from "services/login/endpointRepository";
import { isUserParentInternal } from "services/tenants/tenantCookieService";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});

const connector = connect(mapState);

const ApiGuideView = (props: ConnectedProps<typeof connector>): JSX.Element => {
    const [showBackToTop, setShowBackToTop] = React.useState(false);

    React.useEffect(() => {
        const handleScroll = (e: Event) => {
            const target = e.target as Element;
            setShowBackToTop(target.scrollTop > 100);
        };
        // Find all DOM elements and filter for scrollable containers with height > 500px and visible overflow
        const allElements = Array.from(document.querySelectorAll("*")) as Element[];
        const scrollableElements = allElements.filter(
            (el) =>
                el.scrollHeight > el.clientHeight &&
                el.scrollHeight > 500 &&
                getComputedStyle(el).overflowY !== "visible"
        );

        scrollableElements.forEach((container) => {
            container.addEventListener("scroll", handleScroll);
        });

        window.addEventListener("scroll", handleScroll);

        return () => {
            scrollableElements.forEach((container) => {
                container.removeEventListener("scroll", handleScroll);
            });
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Find the largest scrollable container on the page and scroll both it and the window to top.
    const scrollToTop = () => {
        const allElements = Array.from(document.querySelectorAll("*")) as Element[];
        // Filter elements to find scrollable containers with content height > 1000px.
        const scrollableElements = allElements.filter(
            (el) => el.scrollHeight > el.clientHeight && el.scrollHeight > 1000
        );

        const mainContainer = scrollableElements.reduce(
            (largest, current) => (current.scrollHeight > largest.scrollHeight ? current : largest),
            scrollableElements[0]
        );

        if (mainContainer) {
            mainContainer.scrollTo({ top: 0, behavior: "smooth" });
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className={style.swaggerView}>
            {showBackToTop && (
                <div onClick={scrollToTop} className={style.backToTopButton}>
                    <BackToTop color={props.theme.secondaryButtonForegroundColor} />
                </div>
            )}
            <IntroductionView />
            <EndpointsView />
            {isUserParentInternal() && <SwaggerUI url={getPublicApiDocumentationUrl()} />}
        </div>
    );
};

export default connector(ApiGuideView);
